import React, { Component } from 'react'

import Title from './title'

class TitleContainer extends Component {

  render() {
    return (
      <Title {...this.props} />
    )
  }

}

TitleContainer.propTypes = Title.propTypes

export default TitleContainer



/** WEBPACK FOOTER **
 ** ./src/components/title/title-container.js
 **/